import {
	Dashboard as DMSDashboard,
	EasyEdit as DMSEasyEdit,
	Filter as DMSFilter,
	Form as DMSForm,
	Grid as DMSGrid,
	Tree as DMSTree,
} from "./index";

/**
 * ## Grids
 * List of all available standard grids.
 *
 * Please use the links below to navigate to the documentation of each grid.
 */
export namespace Grids {
	/**
	 * Click {@link Dashboard|here} for the documentation of Dashboard.
	 */
	export const Dashboard = DMSDashboard;
	/**
	 * Click {@link EasyEdit|here} for the documentation of EasyEdit.
	 */
	export const EasyEdit = DMSEasyEdit;
	/**
	 * Click {@link Filter|here} for the documentation of Filter.
	 */
	export const Filter = DMSFilter;
	/**
	 * Click {@link Form|here} for the documentation of Form.
	 */
	export const Form = DMSForm;
	/**
	 * Click {@link Grid|here} for the documentation of Grid.
	 */
	export const Grid = DMSGrid;
	/**
	 * Click {@link Tree|here} for the documentation of Tree.
	 */
	export const Tree = DMSTree;
}
